import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  HiChartBar,
  HiTrendingUp,
  HiPhotograph,
  HiCash,
  HiCollection,
  HiArrowLeft,
} from 'react-icons/hi';
import WbShell from '../wb-preview/WbShell';
import BrandLogo from '../components/BrandLogo';
import apiClient from '../api/client';
import MvpDashboard from './MvpDashboard';
import MvpAvitoAds from './MvpAvitoAds';
import MvpAvitoListings from './MvpAvitoListings';
import MvpOzonPanel from './MvpOzonPanel';
import MvpUnitEconomics from './MvpUnitEconomics';

const TABS = [
  { id: 'dashboard', label: 'Дашборд', icon: HiChartBar },
  { id: 'ozon', label: 'Ozon', icon: HiTrendingUp },
  { id: 'avito', label: 'Авито', icon: HiCollection },
  { id: 'avito-ads', label: 'Avito Ads', icon: HiPhotograph },
  { id: 'ue', label: 'Юнит-экономика', icon: HiCash },
];

export default function MvpHub() {
  const { clientId } = useParams();
  const [tab, setTab] = useState('dashboard');
  const [clientName, setClientName] = useState('');
  const [accessError, setAccessError] = useState('');

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/mvp/dashboard', { params: { client_id: clientId } })
      .then(({ data }) => {
        if (!cancelled) {
          setClientName(data?.client?.name || '');
          setAccessError('');
        }
      })
      .catch((e) => {
        if (!cancelled) {
          const msg = e.response?.data?.message;
          const status = e.response?.status;
          if (status === 404) {
            setAccessError('MVP API не найден — перезапустите сервер (node server.js)');
          } else {
            setAccessError(msg || 'Нет доступа к MVP-кабинету');
          }
        }
      });
    return () => { cancelled = true; };
  }, [clientId]);

  return (
    <WbShell banner={false}>
      <div className="flex min-h-screen">
        <aside className="w-56 border-r border-[var(--wb-border)] bg-[var(--wb-surface)] p-4 flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <BrandLogo size={32} />
            <div>
              <p className="text-sm font-bold">Мульти-канал</p>
              <p className="text-xs text-[var(--wb-text-muted)] truncate">{clientName || 'Демо'}</p>
            </div>
          </div>

          <Link
            to={`/client/${clientId}`}
            className="flex items-center gap-2 text-sm text-[var(--wb-text-muted)] hover:text-[var(--wb-primary)]"
          >
            <HiArrowLeft className="w-4 h-4" />
            Кабинет WB
          </Link>

          <nav className="flex flex-col gap-1">
            {TABS.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  tab === t.id
                    ? 'bg-[var(--wb-primary)] text-white'
                    : 'text-[var(--wb-text-secondary)] hover:bg-[var(--wb-surface-muted)]'
                }`}
              >
                <t.icon className="w-4 h-4" />
                {t.label}
              </button>
            ))}
          </nav>

          <p className="text-xs text-[var(--wb-text-muted)] mt-auto">
            MVP · только демо-кабинеты
          </p>
        </aside>

        <main className="flex-1 p-6 overflow-auto">
          {accessError ? (
            <div className="wb-card p-6 text-center">
              <p className="text-[var(--wb-danger)] font-medium">{accessError}</p>
              <p className="text-sm text-[var(--wb-text-muted)] mt-2">
                Запустите: node scripts/seed_mvp_demo.js
              </p>
            </div>
          ) : (
            <>
              {tab === 'dashboard' && <MvpDashboard clientId={clientId} />}
              {tab === 'ozon' && <MvpOzonPanel clientId={clientId} />}
              {tab === 'avito' && <MvpAvitoListings clientId={clientId} />}
              {tab === 'avito-ads' && <MvpAvitoAds clientId={clientId} />}
              {tab === 'ue' && <MvpUnitEconomics clientId={clientId} />}
            </>
          )}
        </main>
      </div>
    </WbShell>
  );
}
